module.exports = {
	"envName": "prod"
};


//////////////////
// WEBPACK FOOTER
// ./src/geogaming-selected.json
// module id = 172
// module chunks = 1